import { Link } from 'react-router-dom';
import styles from './ArtworkCard.module.css';

function ArtworkCard({ artwork }) {
  return (
    <Link to={`/artwork/${artwork.id}`} className={styles.card}>
      <div className={styles.imageWrapper}>
        {artwork.image ? (
          <img src={artwork.image} alt={artwork.title} className={styles.image} />
        ) : (
          <div className={styles.placeholder}>{artwork.title.charAt(0)}</div>
        )}
      </div>
      <div className={styles.info}>
        <h3 className={styles.title}>{artwork.title}</h3>
        <span className={styles.price}>${artwork.price}</span>
      </div>
    </Link>
  );
}

export default ArtworkCard;
